import biApi from "../../../../api/biApi";
import { pageRoutes } from "../../../../routes";
import type { BiApiClientBase } from "../sv/contexts/BiApiClientProviderContext";

export const artifactSharingApiClient: BiApiClientBase = {
  getReportSharing: (artifactId) => biApi.smartViewArtifacts.getSharing(artifactId),
  updateReportSharing: (artifactId, request) => biApi.smartViewArtifacts.updateSharing(artifactId, request),
  validateName: () => Promise.resolve({ success: false, error: { message: "This action is not available here." } }),
  getEditReportUrl: () => "",
  getViewReportUrl: (clientCode, artifactId) => `/${clientCode}/${pageRoutes.aiDashboards}/${artifactId}/view`,
};
